import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import exploreBg from '@assets/dashboard/explore-degrees-bg.png';
import { Button } from '@new/common/ui';

export const ExploreDegreesCard: FC = () => {
  const navigate = useNavigate();

  const onBrowse = () => {
    navigate({ to: '/degrees' });
  };

  return (
    <section className="relative flex h-full min-h-80 flex-col justify-between overflow-hidden rounded-[26px] p-7 shadow-[0_0_4px_rgba(0,0,0,0.25)] lg:min-h-72 lg:px-7">
      <img
        src={exploreBg}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover object-top lg:object-[center_35%]"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-linear-to-b from-white/20 via-[#191818]/20 to-black/20"
      />

      <div className="relative flex flex-col gap-2">
        <p className="bold m-0! [font-family:var(--font-montserrat)] text-[10px] tracking-[1.8px] text-[#7e8b96] uppercase">
          Find your fit
        </p>
        <h2 className="m-0! text-lg! bold text-(--neutral-black-NB900)! lg:[font-size:var(--fs-h5)]!">
          Explore degrees Newlane offers
        </h2>
      </div>

      <Button
        variant="ghost"
        onClick={onBrowse}
        className="relative mt-auto flex w-fit cursor-pointer items-center gap-2 rounded-lg bg-(--primary-O100) px-3 py-2 transition-colors"
      >
        <span className="l5 bold text-(--neutral-black-NB900)">Browse degrees</span>
        <ArrowRight className="size-4 text-(--neutral-black-NB900) lg:size-4.5" />
      </Button>
    </section>
  );
};
